export default __webpack_public_path__ + "static/media/aswan.f7ff19e1.jpeg";